module.exports = __webpack_public_path__ + "images/pages/lp/comment_balloon_5_bdac192ea63ca38f87ba5bde060dc6b4.png";